import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as StationActions from './station.actions';
import { StationLongDto } from '@api/rest';
import { getFromLocalStorage, setInLocalStorage } from '@app/core/utils/localstorage-utils';

export const stationsFeatureKey = 'stations';

export interface State extends EntityState<StationLongDto> {
  selected: string;
  favorites: string[];
  selectedSubstation: string;
}

export const adapter: EntityAdapter<StationLongDto> = createEntityAdapter<StationLongDto>({
  selectId: station => station._id,
});

export const initialState: State = adapter.getInitialState({
  selected: undefined,
  favorites: getFavoritesFromLocalStorage(),
  selectedSubstation: undefined
});


export const reducer = createReducer(
  initialState,
  on(StationActions.loadStationsSuccess, (state, action) =>
    adapter.setAll(action.stations, state)
  ),
  on(StationActions.getStationSuccess, (state, action) =>
    adapter.upsertOne(action.station, state)
  ),
  on(StationActions.setSelectedStation, (state, action) =>
    ({ ...state, selected: action.id })
  ),
  on(StationActions.setSelectedSubstation, (state, action) =>
    ({ ...state, selected: action.id })
  ),
  on(StationActions.addFavorite, (state, action) => {
    const updatedFavorites = !state.favorites.includes(action.favorite)
        ? [...state.favorites, action.favorite]
        : [...state.favorites];
    setInLocalStorage('favorites', updatedFavorites);

    return {
      ...state,
      favorites: updatedFavorites
    };
  }),
  on(StationActions.removeFavorite, (state, action) => {
    const updatedFavorites = state.favorites.filter(favorite => favorite !== action.favorite);
    setInLocalStorage('favorites', updatedFavorites);

    return {
      ...state,
      favorites: updatedFavorites
    };
  }),
  on(StationActions.clearFavorites, (state) => {
    setInLocalStorage('favorites', []);
    return {
      ...state,
      favorites: []
    };
  }),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();

function getFavoritesFromLocalStorage(): string[] {
  const favorites = getFromLocalStorage('favorites');
  if (favorites) {
    return favorites;
  } else {
    return [];
  }
}
